import React from 'react'
import MainTemplate from './components/MainTemplate/MainTemplate'
import { useSearchParams, useNavigate } from 'react-router-dom';
import Heading from './components/Heading/Heading';
import Paragraph from './components/Paragraph/Paragraph';
import Button from '@mui/material/Button';
import { getCampusPaymentCharges, getPaymentResumeState } from './utils/campusPaymentCharges.js';
import { cardPaymentSteps, formatMoney } from './utils/campusPaymentSteps.js';

import { Grid } from '@mui/material';


const PaymentError = () => {
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const college = searchParams.get('college');
    const SessionID = searchParams.get('session_id') || searchParams.get('SessionId');

    const knownKeys = new Set(['college', 'session_id', 'SessionId']);
    const extraParams = [];
    searchParams.forEach((value, key) => {
        if (!knownKeys.has(key) && value) {
            extraParams.push(`${key}: ${value}`);
        }
    });

    const gatewayMessage =
        searchParams.get('ResponseText') ||
        searchParams.get('responseText') ||
        searchParams.get('Error') ||
        searchParams.get('error') ||
        searchParams.get('Message') ||
        searchParams.get('message') ||
        searchParams.get('ResponseCode') ||
        extraParams.join(' | ');


    // When this was the second payment, the first is paid and stays paid.
    const failedCollege = searchParams.get('college') || '';
    const failedSession = searchParams.get('session_id') || '';
    const paidSoFar = cardPaymentSteps(getCampusPaymentCharges())
        .filter((step) => step.paid && String(step.SessionID) !== String(failedSession));

    const content = <>
        <Grid container mt={1} spacing={2}>
            <Grid item sm={12} xs={12} sx={{ textAlign: 'center' }}>
                <Heading text={"Payment could not be completed."} />
                {gatewayMessage ? (
                    <Paragraph text={`BPoint: ${gatewayMessage}`} />
                ) : (
                    <>
                        <Paragraph text={'The BPoint payment form failed before checkout finished. This often happens when the frontend script URL does not match the backend environment (UAT vs production).'} />
                        <Paragraph text={'Please try again. If it keeps failing, contact the office with your parent code and college.'} />
                    </>
                )}
                <Paragraph text={'Feel free to contact us on the provided details'} />
                {paidSoFar.length > 0 && (
                    <Paragraph text={`Your payment for ${paidSoFar.map((step) => `${step.college} (${formatMoney(step.amount)})`).join(' and ')} went through and is safe. Only the payment for ${failedCollege || 'this campus'} did not go through, and you do not need to pay ${paidSoFar.length === 1 ? paidSoFar[0].college : 'those campuses'} again.`} />
                )}
                <Button
                    variant="contained"
                    sx={{ mt: 2 }}
                    onClick={() => {
                        const resume = getPaymentResumeState();
                        if (resume && resume.SessionID) {
                            navigate('/bpointpaymentform', {
                                replace: true,
                                state: resume,
                            });
                            return;
                        }
                        navigate('/payment', { replace: true, state: resume });
                    }}
                >
                    Back to payment
                </Button>
            </Grid>
        </Grid>

    </>

    return (
        <MainTemplate college={college} content={content} SessionID={SessionID} />
    )
}

export default PaymentError
